<div class="container">

  <app-header-dialog [iconName]="'brightness_5'">
    Dia
  </app-header-dialog>


  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !_dayService.spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <div class='bread-crumb' flex>
    <mat-icon color="accent">arrow_right</mat-icon>
    {{ _dayService.breadCrumb(_dayService.currentEvent.name) }}
    <mat-icon color="accent">arrow_right</mat-icon>
    {{ _dayService.breadCrumb(_dayService.localTitle) }}
  </div>

  <mat-tab-group>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>brightness_5</mat-icon>
        <div>Dia</div>
      </ng-template>

      <div class='tab-content'>

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Data</mat-label>
          <input matInput [matDatepicker]="picker" [errorStateMatcher]="matcher" [formControl]="dayForm.controls.date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="dayForm.controls.date.hasError('required')">
            A data é obrigatoria
          </mat-error>
        </mat-form-field>

        <mat-form-field class="name-width" appearance="outline">
          <mat-label>Nome</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="dayForm.controls.name"
            autocomplete="off">
          <mat-error *ngIf="dayForm.controls.name.hasError('required')">
            O Nome é obrigatório
          </mat-error>
        </mat-form-field>

        <div style="width: 820px;">
          <ckeditor [config]="{ 
                    toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
            [formControl]="dayForm.controls.text" [editor]="Editor"></ckeditor>
          <mat-error *ngIf="dayForm.controls.text.hasError('required')">
            O Texto é obrigatório
          </mat-error>
        </div>

      </div>
      
      <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button mat-raised-button (click)='insert()' [disabled]="dayForm.invalid" *ngIf="!_dayService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
        <button mat-raised-button (click)='update()' [disabled]="dayForm.invalid" *ngIf="_dayService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>

    </mat-tab>

    <mat-tab *ngIf='_dayService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>filter_tilt_shift</mat-icon>
        <div>Atividades</div>
      </ng-template>

      <div class='tab-content-ativ'>

        <!-- TABLE -->
        <mat-table [dataSource]="activityDataSource" matSort matSortActive="startTime" matSortDirection='asc'
          matSortDisableClear=true style='height: calc(100vh - 200px); overflow:auto; margin: 0;'
          *ngIf='_dayService.isEdit'>

          <!-- icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>filter_tilt_shift</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- startTime Column -->
          <ng-container matColumnDef="startTime">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Hora </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.startTime }} </mat-cell>
          </ng-container>

          <!-- room Column -->
          <ng-container matColumnDef="location">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Auditório </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.location }}
            </mat-cell>
          </ng-container>

          <!-- atividade Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Depto/Atividade </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div stle="display: flex; flex-direction: row;">
                <div style="padding: 10px 0 3px 0;">
                  <span>&#x25CF;<i>{{ element.depto }}</i></span>
                </div>
                <div style="padding: 3px 0 10px 0;">
                  {{ element.name }}
                </div>
              </div>

            </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openActivityDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>


          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef>

              <a mat-button (click)="openActivityDialog(null)">
                <mat-icon color='primary'>add_circle_outline</mat-icon>
              </a>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='deleteActivity(element)' style='background-color: whitesmoke;'>
                <mat-icon style='font-size:1.5em; color:rgba(247, 10, 10, 0.7)'>delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedColumns;">
          </mat-row>

        </mat-table>
        <!-- END TABLE -->
      </div>

    </mat-tab>

  </mat-tab-group>

</div>